import { CoreEntity } from "src/engine/entity/CoreEntity";

export class Marker extends CoreEntity {
  static type = "Marker";
  public type = "Marker";
}
